import React from 'react';

import strings from '../../../../lang/lang';
import modal from './../../../../elements/ModalContainer/ModalContainer.module.scss';
import { ModalContainer, Button } from '../../../../elements';
import { webhookActions } from '../../../../redux/reducers/webhook';
import { useAppDispatch } from '../../../../hooks/useRedux';

interface IModal {
  closeModal: (v?: object) => any;
}

function GenerateNewSecret(props: IModal) {
  const { closeModal } = props;
  const dispatch = useAppDispatch();

  function generateNewWebhookSecret() {
    new Promise((res, rej) => {
      dispatch(webhookActions.generateNewSecret({ res, rej }));
    })
    .finally(() => {
      closeModal({});
    });
  }
  return (
    <ModalContainer
      isOpen
      closeModalWindow={() => closeModal({})}
      title={strings.appWebhookDetails.text.modalNewSecretTitle}
    >
      <div className={modal['react-modal__btn-box']}>
        <Button
          name={strings.appWebhookDetails.buttons.generate}
          type="submit"
          variant="primary"
          secondaryClassName="popup_primary"
          onClick={() => generateNewWebhookSecret()}
        />
      </div>
      <Button
        name={strings.appWebhookDetails.buttons.cancel}
        type="submit"
        variant="secondary"
        secondaryClassName="popup_secondary"
        onClick={() => closeModal({})}
      />
    </ModalContainer>
  );
}

export default GenerateNewSecret;
